import { useEffect, useState } from 'react';

const LOADING_INTERVAL = 2500;
const LOADING_MESSAGES = [
  'We’re building a consolidated Inbox to rule them all.',
  'We’re creating text templates so you can just hit “Send.”',
  'We’re creating a chat tool for your website.',
  'We’re generating your new, textable Podium number.',
];

const useLoadingMessagesRotation = ({
  isInfiniteLoop,
  loadingInterval = LOADING_INTERVAL,
  loadingMessages = LOADING_MESSAGES,
} = {}) => {
  const [message, setMessage] = useState(loadingMessages[0]);

  useEffect(() => {
    let i = 0;
    const messagesLength = loadingMessages.length - 1;

    const rotateLoadingTextInterval = setInterval(() => {
      if (i < messagesLength) {
        ++i;
      } else {
        isInfiniteLoop ? (i = 0) : clearInterval(rotateLoadingTextInterval);
      }
      setMessage(loadingMessages[i]);
    }, loadingInterval);

    return () => clearInterval(rotateLoadingTextInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return message || '';
};

export default useLoadingMessagesRotation;
